import React, { useEffect, useState } from 'react';

import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  styled,
  Box,
} from '@mui/material';
import SuperUserService from '../../../services/SuperUserService';
import dayjs from 'dayjs';

const DialogActionsStyled = styled(DialogActions)(() => ({ justifyContent: 'space-between' }));

// COMPONENT
function ResetPasswordHistoryModal({ userId, open, onClose }) {
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setIsLoading(true);
      SuperUserService.getResetPasswordHistory(userId)
        .then((resp) => {
          setDataSource(resp);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [open, userId]);

  return (
    <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography component="span" variant="h5">
          Histórico de Recuperação de Senha
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center' }}>{isLoading && <CircularProgress />}</Box>

          {!isLoading && (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Código</TableCell>
                  <TableCell>Expira em</TableCell>
                  <TableCell>Expirado</TableCell>
                  <TableCell>Criado em</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {dataSource.map((u) => (
                  <TableRow key={u.id}>
                    <TableCell>{u.code}</TableCell>
                    <TableCell>{dayjs(u.expiresAt).format('DD/MM/YYYY HH:mm')}</TableCell>
                    <TableCell>{dayjs().isAfter(dayjs(u.expiresAt)) ? 'Sim' : 'Não'}</TableCell>
                    <TableCell>{dayjs(u.createdAt).format('DD/MM/YYYY HH:mm')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Grid>
      </DialogContent>

      <DialogActionsStyled>
        <Button variant="outlined" onClick={onClose}>
          Fechar
        </Button>
      </DialogActionsStyled>
    </Dialog>
  );
}

export default ResetPasswordHistoryModal;
